import { render } from "./WaitingPage.vue?vue&type=template&id=3e2b2c33&bindings={}"
import script from "./WaitingPage.vue?vue&type=script&lang=js"
export * from "./WaitingPage.vue?vue&type=script&lang=js"
script.render = render

export default script